import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { Action } from 'hljd'
import { toJS } from 'mobx'

const Item = Action.Item

@observer
export default class extends Component {
  render() {
    const { store } = this.props
    const statusCount = toJS(store.statusCount)
    return (
      <Action
        style={{ padding: '0 20px' }}
        onChange={store.onTableChane}
        active={store.status}
      >
        <Item value="1">
          <span>已上架</span>
          <span className="googs-num">
            {statusCount.on_sale ? statusCount.on_sale.count : 0}
          </span>
        </Item>
        <Item value="2">
          <span>审核中</span>
          <span className="googs-num">
            {statusCount.pending ? statusCount.pending.count : 0}
          </span>
        </Item>
        <Item value="3">
          <span>审核未通过</span>
          <span className="googs-num">
            {statusCount.unpass ? statusCount.unpass.count : 0}
          </span>
        </Item>
        <Item value="4">
          <span>已下架</span>
          <span className="googs-num">
            {statusCount.sold_out ? statusCount.sold_out.count : 0}
          </span>
        </Item>
      </Action>
    )
  }
}
